<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Casual Worker</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Worker</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="row">
                  <div class="col-md-3">
                    <button
                      class="btn btn-primary dropdown-toggle view-icons"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      More
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item" @click="openImportDialog"
                        >Import</a
                      >
                      <a class="dropdown-item" @click="exportEmployee"
                        >Export</a
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <a class="btn add-btn" @click="openDialog"
                      ><i class="fa fa-plus"></i> Add Worker</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <!-- <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpId"
                  style="height: 55px !important"
                />
                <label class="focus-label">Worker ID</label>
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpName"
                  style="height: 55px !important"
                />
                <label class="focus-label">Worker Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <multiselectvue
                  class="from-control"
                  v-model="newEmployeeDesignation"
                  placeholder="Select Designation"
                  :custom-label="nameOfDesignation"
                  :options="sortedEmployeeDesignation"
                  :searchable="true"
                  @select="optionSelectDesignation"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.name
                  }}</template>
                </multiselectvue>
                <!-- <select
                  class="form-control"
                  style="height: 55px !important"
                  v-model="filterDesignationId"
                >
                  <option>Select Designation</option>
                  <option
                    v-for="item in designations"
                    :key="item.id"
                    :value="parseInt(item.id)"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <label class="focus-label">Designation</label> -->
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a @click="getFilter" class="btn btn-success btn-block">
                Search
              </a>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <v-data-table
                :headers="headers"
                :items="employees"
                :loading="loading"
                loading-text="Loading... Please wait"
                sort-by=""
                class="elevation-1 table"
              >
                <template v-slot:[`item.profile`]="{ item }">
                  <h2 class="table-avatar">
                    <router-link
                      :to="{ name: 'workerdetail', params: { id: item.id } }"
                      class="avatar"
                      ><img
                        alt=""
                        src="~@/assets/profiles/avatar-02.jpg"
                        v-if="!item.passportPhoto"/>
                      <img
                        alt=""
                        :src="media + item.passportPhoto"
                        width="38"
                        v-if="item.passportPhoto"
                    /></router-link>
                    <router-link
                      :to="{ name: 'workerdetail', params: { id: item.id } }"
                      v-if="item.status == 3"
                      ><p>{{ item.firstName + " " + item.lastName }}</p>
                      <span>{{ item.designation.name }}</span>
                    </router-link>
                    <router-link
                      :to="{ name: 'workerdetail', params: { id: item.id } }"
                      v-else
                      >{{ item.firstName + " " + item.lastName }}
                      <span>{{ item.designation.name }}</span>
                    </router-link>
                  </h2>
                </template>
                <template v-slot:[`item.joinDate`]="{ item }">
                  {{
                    item.joinDate
                      ? new Date(item.joinDate).toLocaleDateString()
                      : ""
                  }}
                </template>
                <template v-slot:[`item.employeeCode`]="{ item }">
                  {{ item.employeeCode }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                      ><i class="material-icons">more_vert</i></a
                    >
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        @click="setEditEmployee(item)"
                        data-toggle="modal"
                        data-target="#edit_employee"
                        ><i class="fa fa-pencil m-r-5"></i> Edit</a
                      >
                      <a
                        class="dropdown-item"
                        @click="setDeletEmployee(item)"
                        data-toggle="modal"
                        data-target="#delete_employee"
                        ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                      >
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Employee Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Casual Worker</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >First Name <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        v-model.trim="$v.firstName.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.firstName.$error
                        }"
                      />
                      <div
                        v-if="submitted && !$v.firstName.required"
                        class="invalid-feedback"
                      >
                        First Name is required
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Last Name</label>
                      <input
                        type="text"
                        v-model.trim="$v.lastName.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.lastName.$error
                        }"
                      />
                      <div
                        v-if="submitted && !$v.lastName.required"
                        class="invalid-feedback"
                      >
                        Last Name is required
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        type="email"
                        v-model.trim="$v.email.$model"
                        id="email"
                        name="email"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.email.$error }"
                      />
                      <div
                        v-if="submitted && $v.email.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.email.required">Email is required</span>
                        <span v-if="!$v.email.email">Email is invalid</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Phone </label>
                      <input
                        type="text"
                        v-model.trim="$v.phone.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.phone.$error }"
                      />
                      <div
                        v-if="submitted && !$v.phone.required"
                        class="invalid-feedback"
                      >
                        Phone is required
                      </div>
                      <div
                        v-if="submitted && !$v.phone.numeric"
                        class="invalid-feedback"
                      >
                        Phone must be numbers
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Business Unit <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model.trim="$v.companyunitId.$model"
                        :class="{
                          'is-invalid': submitted && $v.companyunitId.$error
                        }"
                      >
                        <option disabled>Select Business Unit</option>
                        <option
                          v-for="item in units"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && !$v.companyunitId.required"
                        class="invalid-feedback"
                      >
                        Business Unit is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Designation <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model.trim="$v.designationId.$model"
                        :class="{
                          'is-invalid': submitted && $v.designationId.$error
                        }"
                      >
                        <option disabled>Select Designation</option>
                        <option
                          v-for="item in designations"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && !$v.designationId.required"
                        class="invalid-feedback"
                      >
                        Designation is required
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Department <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model.trim="$v.departmentId.$model"
                        :class="{
                          'is-invalid': submitted && $v.departmentId.$error,
                        }"
                      >
                        <option disabled>Select Department</option>
                        <option
                          v-for="item in departments"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && !$v.departmentId.required"
                        class="invalid-feedback"
                      >
                        Department is required
                      </div>
                    </div>
                  </div> -->

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Level <span class="text-danger">*</span></label>

                      <select
                        class="form-control"
                        v-model.trim="$v.rankId.$model"
                        :class="{ 'is-invalid': submitted && $v.rankId.$error }"
                      >
                        <option>Select Level</option>
                        <option
                          v-for="item in ranks"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.rankName }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && !$v.rankId.required"
                        class="invalid-feedback"
                      >
                        Level is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Joined Date</label>
                      <div class="cal-icon">
                        <datepicker
                          v-model.trim="$v.joinedDate.$model"
                          bootstrap-styling
                          class="datetimepicker"
                          type="date"
                          :class="{
                            'is-invalid': submitted && $v.joinedDate.$error
                          }"
                        />
                      </div>
                      <div
                        v-if="submitted && !$v.joinedDate.required"
                        class="invalid-feedback"
                      >
                        Joined Date is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- /Add Employee Modal -->

        <!-- Edit Employee Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Casual Worker</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeEdit"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onPutSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >First Name <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        v-model="employee.firstName"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Last Name</label>
                      <input
                        class="form-control"
                        v-model="employee.lastName"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Phone </label>
                      <input
                        class="form-control"
                        v-model="employee.phone"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Business Unit <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model="employee.companyUnitId"
                        v-if="employee"
                      >
                        <option>Select Business Unit</option>
                        <option
                          v-for="item in units"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Designation <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model="employee.designationId"
                        v-if="employee"
                      >
                        <option>Select Designation</option>
                        <option
                          v-for="item in designations"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Level <span class="text-danger">*</span></label>

                      <select
                        class="form-control"
                        v-model="employee.rankId"
                        v-if="employee"
                      >
                        <option>Select Level</option>
                        <option
                          v-for="item in ranks"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.rankName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Joined Date</label>
                      <div class="cal-icon">
                        <datepicker
                          v-model="employee.joinDate"
                          bootstrap-styling
                          class="datetimepicker"
                          type="date"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Employee Modal -->

        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Casual Worker</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="removeEmployee"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                    >
                      Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Casual Worker</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Casual Worker</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards <strong>Designation</strong> and
                    <strong>Level</strong> columns you are expected to get the
                    value from their representing sheet. <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importEmployee"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, numeric, sameAs } from "vuelidate/lib/validators";
import { workerService } from "@/services/workerService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      firstName: "",
      lastName: "",
      email: "",
      rankId: null,
      address: "",
      newEmployeeDesignation: "",
      phone: "",
      joinedDate: new Date(),
      designationId: null,
      departmentId: null,
      companyunitId: null,
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Name",
          value: "profile"
        },
        { text: "Worker Code", value: "employeeCode" },
        { text: "Bus. Unit", value: "companyUnit.name" },
        { text: "Mobile", value: "phone" },
        { text: "Join Date", value: "joinDate" },
        { text: "Gender", value: "gender" },
        { text: "Action", value: "actions", sortable: false }
      ],
      employees: [],
      employee: {},
      designations: [],
      departments: [],
      units: [],
      ranks: null,
      submitted: false,
      loading: false,
      error: "",
      message: "",
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      filterEmpId: "",
      filterEmpName: "",
      filterDesignationId: "",
      designationStrings: "",
      unitStrings: "",
      rankStrings: "",
      nofilterEmployees: [],
      employeeGroups: [],
      file: null,
      fileName: ""
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    email: { required },
    rankId: { required },
    joinedDate: { required },
    phone: { required, numeric },
    designationId: { required },
    departmentId: { required },
    companyunitId: { required }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  created() {
    this.GetEmployees();
  },

  computed: {
    sortedEmployeeDesignation: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.designations.sort(compare);
    }
  },

  methods: {
    nameOfDesignation({ name }) {
      return `${name}`;
    },

    optionSelectDesignation(option, id) {
      console.log(option.id, this.newEmployeeDesignation.id);
      this.filterDesignationId = option.id;
    },

    GetDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;

          var designationStrings = "";
          model.forEach(t => {
            designationStrings += t.id + " - " + t.name + ", ";
          });
          this.designationStrings = designationStrings;
        },
        error => {
          this.error = error;
        }
      );
    },

    getDepartments() {
      organizationService.getDepartments().then(model => {
        this.departments = model;
      });
    },
    GetUnits() {
      organizationService.getCompanyUnits(this.company.id).then(
        model => {
          this.units = model;

          var unitStrings = "";
          model.forEach(t => {
            unitStrings += t.id + " - " + t.name + ", ";
          });
          this.unitStrings = unitStrings;
        },
        error => {
          this.error = error;
        }
      );
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    getFilter() {
      console.log(this.filterEmpId);
      this.employees = this.nofilterEmployees;
      var employee = [];
      if (this.filterEmpId != "") {
        this.employees = this.nofilterEmployees.filter(
          c =>
            c.employeeCode != null &&
            c.employeeCode.toLowerCase().match(this.filterEmpId.toLowerCase())
        );
      }
      if (this.filterEmpName != "" && this.filterDesignationId != "") {
        this.employees = this.nofilterEmployees.filter(
          c =>
            this.filterEmpName.toLowerCase().match(c.firstName.toLowerCase()) ||
            this.filterEmpName.toLowerCase().match(c.lastName.toLowerCase()) ||
            c.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (this.filterEmpName != "" && this.filterDesignationId == "") {
        this.employees = this.nofilterEmployees.filter(
          c =>
            c.firstName
              .toLowerCase()
              .includes(this.filterEmpName.toLowerCase()) ||
            c.lastName.toLowerCase().includes(this.filterEmpName.toLowerCase())
        );
      }
      if (this.filterEmpName == "" && this.filterDesignationId != "") {
        this.employees = this.nofilterEmployees.filter(
          c => c.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (
        this.filterEmpId == "" &&
        this.filterEmpName == "" &&
        this.filterDesignationId == ""
      ) {
        this.employees = this.nofilterEmployees;
      }
    },
    GetRanks() {
      organizationService.getRanks().then(
        model => {
          this.ranks = model;
          var rankStrings = "";
          model.forEach(t => {
            rankStrings += t.id + " - " + t.rankName + ", ";
          });
          this.rankStrings = rankStrings;
        },
        error => {
          this.error = error;
        }
      );
    },

    GetEmployees() {
      this.loading = true;
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      workerService.GetCasualWorkers(unit.id).then(
        model => {
          (this.employees = model), (this.nofilterEmployees = model);
          (this.loading = false), (this.companyUnitId = unit.id);
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    importEmployee() {
      workerService.ImportCasualWorker(this.company.id, this.file).then(
        response => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          workerService.GetCasualWorkers(unit.id).then(model => {
            (this.employees = model), (this.filterEmployees = model);
            //this.message = '';
            this.dialogImport = false;
          });
        },
        error => {
          this.error = error;
        }
      );
    },

    exportEmployee() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      workerService.exportCasualWorker(unit.id).then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },

    downloadTemplate() {
      workerService
        .downloadCasualWorkerTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },

    setEmployee(employee) {
      this.employee = employee;
    },

    removeEmployee() {
      //   if(this.employee){
      workerService.removeCasualWorker(this.employee.id).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          workerService.GetCasualWorkers(unit.id).then(model => {
            (employees = model), (this.filterEmployees = model);
          });
        },
        error => {
          this.error = error;
        }
      );
      //   }
    },

    setEditEmployee(model) {
      this.employee = model;
      this.dialogEdit = true;
    },

    setDeletEmployee(model) {
      this.employee = model;
      this.dialogDelete = true;
    },

    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return;
      // }

      this.loading = true;
      workerService
        .addCasualWorker(
          this.company.id,
          this.rankId,
          this.firstName,
          this.lastName,
          this.email,
          this.phone,
          this.designationId,
          this.companyunitId,
          this.joinedDate
        )
        .then(
          id => {
            this.message = "New Worker Added successfully";
            var unit = JSON.parse(localStorage.getItem("companyUnit"));
            workerService.GetCasualWorkers(unit.id).then(model => {
              (this.employees = model), (this.filterEmployees = model);
              //this.message = '';
              this.dialog = false;
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    onPutSubmit() {
      this.submitted = true;
      workerService
        .UpdateCasualWorker(
          this.employee.id,
          this.company.id,
          this.employee.rankId,
          this.employee.firstName,
          this.employee.lastName,
          this.employee.email,
          this.employee.phone,
          this.employee.designationId,
          this.employee.companyUnitId,
          this.employee.joinDate
        )
        .then(
          id => {
            this.message = "Worker update successfully";
            var unit = JSON.parse(localStorage.getItem("companyUnit"));
            workerService.GetCasualWorkers(unit.id).then(model => {
              this.employees = model;
              //this.message = '';
              this.dialogEdit = false;
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    clearModel() {
      this.firstName = "";
      this.lastName = "";
      this.rankId = null;
      this.address = "";
      this.phone = "";
      this.email = "";
      this.designationId = null;
      this.companyunitId = null;
      // this.employee = null;
      this.error = "";
      this.message = "";
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    openImportDialog() {
      this.dialogImport = true;
    },
    closeEdit() {
      this.dialogEdit = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
    closeImport() {
      this.dialogImport = false;
    }
  },

  mounted() {
    this.GetRanks();
    this.GetDesignations();
    this.GetUnits();
    this.getDepartments();
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeeslist"
};
</script>



// WEBPACK FOOTER //
// src/components/casualworker/main.vue